module.exports = __webpack_public_path__ + "static/shifaaz-shamoon-sLAk1guBG90-unsplash-47e91af7b69c20cdccc108cd931d8391.jpg";